import { ApolloClient, HttpLink, InMemoryCache /*, split */ } from '@apollo/client/core'
// import { WebSocketLink } from '@apollo/client/link/ws'
//import WebSocketLink from './websocketlink/'
import { setContext } from '@apollo/client/link/context'
// import { getMainDefinition } from '@apollo/client/utilities'
import user from '@iez/lib/user/'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { reactive } from '@vue/composition-api'

export const config = reactive({
  project: ``,
  stripeKey: ``
})

export default ({ project, stripeKey }) => {
  config.project = project
  config.stripeKey = stripeKey
  const uri = `https://${project}.herokuapp.com/v1/graphql`
  //const uriWs = `wss://${project}.herokuapp.com/v1/graphql`
  const cache = new InMemoryCache()
  const linkHttp = new BatchHttpLink({
    uri,
    batchInterval: 50
  })

  const linkAuth = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      ...headers,
      ...user.token
        ? {
          authorization: `Bearer ${user.token}`
        } : null
    }
  })
  /* const connectionParams = () => ({
    headers: {
      ...user.token ? {
        Authorization: `Bearer ${user.token}`
      } : undefined
    }
  }) */

  /* const linkWebsocket = new WebSocketLink({
    uri: uriWs,
    params: {
      connectionParams
    }
  }) */

  /* const link = split(
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query)
      return kind === 'OperationDefinition' && operation === 'subscription'
    },
    // linkWebsocket,
    linkHttp
  ) */

  const link = linkAuth.concat(linkHttp)

  const client = new ApolloClient({
    cache,
    link,
    connectToDevTools: true
  })

  return client
}
